import { isNil } from 'lodash/fp';
import { type WebPageDataFragment } from '../../../../api/fragments/WebPageData';
import { useThemeComponents } from '../../../../themes';
import useTranslatedString from '../../../../utilities/useTranslatedString';
import WebPageBlock from './blocks';
import CompanyDetails from './CompanyDetails';
import LiveChat from './LiveChat';
import Locations from './Locations';
import MainDetailImage from './MainDetailImage';
import { WebPagePageTitle, WebpageLayout } from './shared';
import WebPageMetaData from './WebPageMetaData';

type MainDetailProps = {
    webpage: WebPageDataFragment;
};

const MainDetail = ({ webpage }: MainDetailProps) => {
    const translated = useTranslatedString();
    const { MobilityWebpageLayout } = useThemeComponents();

    const { module } = webpage;
    if (module.__typename !== 'WebsiteModule') {
        throw new Error('Module not found');
    }

    return (
        <>
            <WebPageMetaData webpage={webpage} />
            <WebpageLayout itemType="https://schema.org/Article" itemScope>
                <MobilityWebpageLayout footerMaxWidth="var(--mobility-page-max-width)">
                    <MainDetailImage webpage={webpage} />
                    <WebPagePageTitle itemProp="headline">{translated(webpage.pageTitle)}</WebPagePageTitle>
                    {webpage.webPageBlock.length > 0 && <WebPageBlock webpageBlock={webpage.webPageBlock} />}
                    <CompanyDetails module={module} />
                    <Locations module={module} />
                    {!isNil(module.liveChatSetting) && (
                        <LiveChat
                            chatSetting={
                                module.liveChatSetting.__typename === 'UserlikeChatbotSetting' && module.liveChatSetting
                            }
                            hasFooter={false}
                        />
                    )}
                </MobilityWebpageLayout>
            </WebpageLayout>
        </>
    );
};

export default MainDetail;
